import { useEffect, useRef } from "react"
import { Play } from "lucide-react"
import type { PlaybackTimeStore } from "@/lib/timeline"

/** Допуск «плейхед в самом начале»: seek(0) даёт ровно 0, 1мс — на float-дрейф. */
const START_EPSILON_MS = 1

/**
 * Центрированная иконка Play поверх видео — подсказывает, что это видео, а не кадр.
 * Видна только на паузе с плейхедом в самом начале: при остановке в произвольном
 * месте не должна загораживать кадр. Видимость через подписку на timeStore
 * с императивным toggle классов — без React-рендеров на каждый тик playback.
 */
export function StartPlayOverlay({ playing, timeStore }: { playing: boolean; timeStore: PlaybackTimeStore }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const update = () => {
      const visible = !playing && timeStore.get() <= START_EPSILON_MS
      ref.current?.classList.toggle("hidden", !visible)
      ref.current?.classList.toggle("flex", visible)
    }
    update()
    return timeStore.subscribe(update)
  }, [playing, timeStore])

  return (
    <div ref={ref} className="pointer-events-none absolute inset-0 z-30 hidden items-center justify-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-black/55 backdrop-blur-sm">
        <Play className="ml-0.5 h-7 w-7 fill-white text-white" />
      </div>
    </div>
  )
}
